export const EmptyAlert = () => {
  return (
    <svg
      width="106"
      height="104"
      viewBox="0 0 106 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_16789_183495)">
        <ellipse
          cx="50.3818"
          cy="91.2756"
          rx="24.7128"
          ry="4.23649"
          fill="#9DA4AE"
          fill-opacity="0.2"
        />
      </g>
      <path
        d="M53.4409 93.1566C76.1573 93.1566 94.5727 74.7389 94.5727 52.0197C94.5727 29.3004 76.1573 10.8828 53.4409 10.8828C30.7244 10.8828 12.3091 29.3004 12.3091 52.0197C12.3091 74.7389 30.7244 93.1566 53.4409 93.1566Z"
        fill="url(#paint0_linear_16789_183495)"
        fill-opacity="0.6"
      />
      <path
        d="M76.1662 19.8047H29.43C26.5168 19.8047 24.1553 22.1662 24.1553 25.0794H81.4409C81.4409 22.1662 79.0793 19.8047 76.1662 19.8047Z"
        fill="#6366F1"
        fill-opacity="0.5"
      />
      <path
        d="M24.1553 24.9375H81.4409V68.5672C81.4409 70.507 80.6703 72.3673 79.2986 73.739C77.927 75.1106 76.0666 75.8812 74.1268 75.8812H31.4693C29.5295 75.8812 27.6692 75.1106 26.2975 73.739C24.9259 72.3673 24.1553 70.507 24.1553 68.5672V24.9375Z"
        fill="url(#paint1_linear_16789_183495)"
      />
      <g filter="url(#filter1_d_16789_183495)">
        <path
          d="M90.7199 7.25H68.6214C67.5916 7.25 66.7568 8.08478 66.7568 9.11454V19.5014C66.7568 20.5311 67.5916 21.3659 68.6214 21.3659H90.7199C91.7496 21.3659 92.5844 20.5311 92.5844 19.5014V9.11454C92.5844 8.08478 91.7496 7.25 90.7199 7.25Z"
          fill="url(#paint2_linear_16789_183495)"
        />
      </g>
      <path
        d="M72.2105 16.4513C73.3944 16.4513 74.3541 15.4916 74.3541 14.3077C74.3541 13.1238 73.3944 12.1641 72.2105 12.1641C71.0266 12.1641 70.0669 13.1238 70.0669 14.3077C70.0669 15.4916 71.0266 16.4513 72.2105 16.4513Z"
        fill="#A9ABF5"
      />
      <path
        d="M79.8707 16.4513C81.0545 16.4513 82.0143 15.4916 82.0143 14.3077C82.0143 13.1238 81.0545 12.1641 79.8707 12.1641C78.6868 12.1641 77.7271 13.1238 77.7271 14.3077C77.7271 15.4916 78.6868 16.4513 79.8707 16.4513Z"
        fill="#A9ABF5"
      />
      <path
        d="M87.5318 16.4513C88.7157 16.4513 89.6754 15.4916 89.6754 14.3077C89.6754 13.1238 88.7157 12.1641 87.5318 12.1641C86.3479 12.1641 85.3882 13.1238 85.3882 14.3077C85.3882 15.4916 86.3479 16.4513 87.5318 16.4513Z"
        fill="#A9ABF5"
      />
      <path
        d="M49.3829 83.796C49.7164 82.4144 51.6817 82.4144 52.0152 83.796C52.1344 84.2898 52.5199 84.6753 53.0136 84.7945C54.3953 85.128 54.3953 87.0933 53.0136 87.4268C52.5199 87.546 52.1344 87.9315 52.0152 88.4252C51.6817 89.8069 49.7164 89.8069 49.3829 88.4252C49.2637 87.9315 48.8782 87.546 48.3844 87.4268C47.0028 87.0933 47.0028 85.128 48.3844 84.7945C48.8782 84.6753 49.2637 84.2898 49.3829 83.796Z"
        fill="#6366F1"
        fill-opacity="0.5"
      />
      <path
        d="M17.6509 28.8637C17.8935 27.8589 19.3228 27.8589 19.5653 28.8637C19.652 29.2228 19.9324 29.5032 20.2915 29.5899C21.2963 29.8324 21.2963 31.2617 20.2915 31.5043C19.9324 31.591 19.652 31.8713 19.5653 32.2304C19.3228 33.2353 17.8935 33.2353 17.6509 32.2304C17.5642 31.8713 17.2839 31.591 16.9248 31.5043C15.9199 31.2617 15.9199 29.8324 16.9248 29.5899C17.2839 29.5032 17.5642 29.2228 17.6509 28.8637Z"
        fill="#6366F1"
        fill-opacity="0.5"
      />
      <path
        d="M19.0215 13.1867C19.3551 11.805 21.3203 11.805 21.6538 13.1867C21.773 13.6804 22.1585 14.0659 22.6523 14.1851C24.034 14.5186 24.034 16.4839 22.6523 16.8174C22.1585 16.9366 21.773 17.3221 21.6538 17.8159C21.3203 19.1975 19.3551 19.1975 19.0215 17.8159C18.9024 17.3221 18.5168 16.9366 18.0231 16.8174C16.6414 16.4839 16.6414 14.5186 18.0231 14.1851C18.5168 14.0659 18.9024 13.6804 19.0215 13.1867Z"
        fill="#6366F1"
        fill-opacity="0.5"
      />
      <mask
        id="path-12-inside-1_16789_183495"
        fill="white"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M51.7232 11.3232C52.4346 11.3232 53.0112 10.7466 53.0112 10.0352C53.0112 9.32389 52.4346 8.74724 51.7232 8.74724C51.0119 8.74724 50.4352 9.32389 50.4352 10.0352C50.4352 10.7466 51.0119 11.3232 51.7232 11.3232ZM51.7232 12.2892C52.9681 12.2892 53.9772 11.2801 53.9772 10.0352C53.9772 8.79039 52.9681 7.78125 51.7232 7.78125C50.4784 7.78125 49.4692 8.79039 49.4692 10.0352C49.4692 11.2801 50.4784 12.2892 51.7232 12.2892Z"
        />
      </mask>
      <path
        d="M51.1568 10.0352C51.1568 9.72242 51.4104 9.46884 51.7232 9.46884V13.1776C53.4587 13.1776 54.8656 11.7707 54.8656 10.0352H51.1568ZM51.7232 10.6016C51.4104 10.6016 51.1568 10.348 51.1568 10.0352H54.8656C54.8656 8.29975 53.4587 6.89286 51.7232 6.89286V10.6016ZM52.2896 10.0352C52.2896 10.348 52.036 10.6016 51.7232 10.6016V6.89286C49.9877 6.89286 48.5809 8.29975 48.5809 10.0352H52.2896ZM51.7232 9.46884C52.036 9.46884 52.2896 9.72242 52.2896 10.0352H48.5809C48.5809 11.7707 49.9877 13.1776 51.7232 13.1776V9.46884ZM52.1228 10.0352C52.1228 10.2559 51.9439 10.4348 51.7232 10.4348V14.1436C53.9922 14.1436 55.8316 12.3042 55.8316 10.0352H52.1228ZM51.7232 9.63563C51.9439 9.63563 52.1228 9.81454 52.1228 10.0352H55.8316C55.8316 7.76625 53.9922 5.92687 51.7232 5.92687V9.63563ZM51.3236 10.0352C51.3236 9.81454 51.5025 9.63563 51.7232 9.63563V5.92687C49.4542 5.92687 47.6149 7.76625 47.6149 10.0352H51.3236ZM51.7232 10.4348C51.5025 10.4348 51.3236 10.2559 51.3236 10.0352H47.6149C47.6149 12.3042 49.4542 14.1436 51.7232 14.1436V10.4348Z"
        fill="#111927"
        fill-opacity="0.38"
        mask="url(#path-12-inside-1_16789_183495)"
      />
      <mask
        id="path-14-inside-2_16789_183495"
        fill="white"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M94.7579 30.081C95.4692 30.081 96.0459 29.5044 96.0459 28.793C96.0459 28.0817 95.4692 27.5051 94.7579 27.5051C94.0465 27.5051 93.4699 28.0817 93.4699 28.793C93.4699 29.5044 94.0465 30.081 94.7579 30.081ZM94.7579 31.047C96.0027 31.047 97.0119 30.0379 97.0119 28.793C97.0119 27.5482 96.0027 26.5391 94.7579 26.5391C93.513 26.5391 92.5039 27.5482 92.5039 28.793C92.5039 30.0379 93.513 31.047 94.7579 31.047Z"
        />
      </mask>
      <path
        d="M94.1915 28.793C94.1915 28.4802 94.4451 28.2267 94.7579 28.2267V31.9354C96.4934 31.9354 97.9003 30.5285 97.9003 28.793H94.1915ZM94.7579 29.3594C94.4451 29.3594 94.1915 29.1059 94.1915 28.793H97.9003C97.9003 27.0576 96.4934 25.6507 94.7579 25.6507V29.3594ZM95.3243 28.793C95.3243 29.1059 95.0707 29.3594 94.7579 29.3594V25.6507C93.0224 25.6507 91.6155 27.0576 91.6155 28.793H95.3243ZM94.7579 28.2267C95.0707 28.2267 95.3243 28.4802 95.3243 28.793H91.6155C91.6155 30.5285 93.0224 31.9354 94.7579 31.9354V28.2267ZM95.1575 28.793C95.1575 29.0137 94.9786 29.1926 94.7579 29.1926V32.9014C97.0269 32.9014 98.8662 31.062 98.8662 28.793H95.1575ZM94.7579 28.3934C94.9786 28.3934 95.1575 28.5723 95.1575 28.793H98.8662C98.8662 26.5241 97.0269 24.6847 94.7579 24.6847V28.3934ZM94.3583 28.793C94.3583 28.5723 94.5372 28.3934 94.7579 28.3934V24.6847C92.4889 24.6847 90.6495 26.5241 90.6495 28.793H94.3583ZM94.7579 29.1926C94.5372 29.1926 94.3583 29.0137 94.3583 28.793H90.6495C90.6495 31.062 92.4889 32.9014 94.7579 32.9014V29.1926Z"
        fill="#111927"
        fill-opacity="0.38"
        mask="url(#path-14-inside-2_16789_183495)"
      />
      <mask
        id="path-16-inside-3_16789_183495"
        fill="white"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M99.2369 20.6748C99.9482 20.6748 100.525 20.0981 100.525 19.3868C100.525 18.6755 99.9482 18.0988 99.2369 18.0988C98.5256 18.0988 97.9489 18.6755 97.9489 19.3868C97.9489 20.0981 98.5256 20.6748 99.2369 20.6748ZM99.2369 21.6408C100.482 21.6408 101.491 20.6316 101.491 19.3868C101.491 18.142 100.482 17.1328 99.2369 17.1328C97.9921 17.1328 96.9829 18.142 96.9829 19.3868C96.9829 20.6316 97.9921 21.6408 99.2369 21.6408Z"
        />
      </mask>
      <path
        d="M98.6705 19.3868C98.6705 19.074 98.9241 18.8204 99.2369 18.8204V22.5292C100.972 22.5292 102.379 21.1223 102.379 19.3868H98.6705ZM99.2369 19.9532C98.9241 19.9532 98.6705 19.6996 98.6705 19.3868H102.379C102.379 17.6513 100.972 16.2444 99.2369 16.2444V19.9532ZM99.8033 19.3868C99.8033 19.6996 99.5497 19.9532 99.2369 19.9532V16.2444C97.5014 16.2444 96.0945 17.6513 96.0945 19.3868H99.8033ZM99.2369 18.8204C99.5497 18.8204 99.8033 19.074 99.8033 19.3868H96.0945C96.0945 21.1223 97.5014 22.5292 99.2369 22.5292V18.8204ZM99.6365 19.3868C99.6365 19.6075 99.4576 19.7864 99.2369 19.7864V23.4951C101.506 23.4951 103.345 21.6558 103.345 19.3868H99.6365ZM99.2369 18.9872C99.4576 18.9872 99.6365 19.1661 99.6365 19.3868H103.345C103.345 17.1178 101.506 15.2784 99.2369 15.2784V18.9872ZM98.8373 19.3868C98.8373 19.1661 99.0162 18.9872 99.2369 18.9872V15.2784C96.9679 15.2784 95.1285 17.1178 95.1285 19.3868H98.8373ZM99.2369 19.7864C99.0162 19.7864 98.8373 19.6075 98.8373 19.3868H95.1285C95.1285 21.6558 96.9679 23.4951 99.2369 23.4951V19.7864Z"
        fill="#111927"
        fill-opacity="0.38"
        mask="url(#path-16-inside-3_16789_183495)"
      />
      <path
        d="M100.513 66.1484C100.515 67.4046 100.059 68.6185 99.2316 69.5636C98.4041 70.5088 97.2612 71.1207 96.0159 71.2853C95.7882 71.3143 95.559 71.3292 95.3296 71.3299H78.0961C77.7223 71.3291 77.3491 71.2983 76.9802 71.2378C75.3961 70.9644 73.969 70.1147 72.9738 68.8522C71.9785 67.5897 71.4854 66.0036 71.5893 64.3992C71.6932 62.7949 72.3868 61.2857 73.5366 60.1621C74.6863 59.0385 76.211 58.38 77.8171 58.3133C78.6496 56.5055 80.0472 55.0175 81.7992 54.0737C83.5512 53.13 85.5625 52.7815 87.5299 53.0811C89.4972 53.3806 91.3138 54.3118 92.7056 55.7343C94.0974 57.1567 94.989 58.9932 95.2458 60.9668H95.324C96.005 60.9657 96.6796 61.0989 97.3092 61.3588C97.9387 61.6187 98.5109 62.0002 98.9928 62.4815C99.4748 62.9627 99.8572 63.5343 100.118 64.1635C100.379 64.7927 100.513 65.4672 100.513 66.1484Z"
        fill="url(#paint3_linear_16789_183495)"
      />
      <path
        d="M5.19239 76.8568C5.19177 78.1078 5.64594 79.3164 6.47028 80.2574C7.29462 81.1984 8.4329 81.8075 9.67302 81.9713C9.89859 82.0027 10.126 82.0185 10.3538 82.0188H27.5119C27.8857 82.0182 28.2589 81.9874 28.6278 81.9267C30.2142 81.6626 31.6458 80.8186 32.6451 79.5584C33.6443 78.2982 34.1399 76.7117 34.0356 75.1067C33.9313 73.5017 33.2347 71.9927 32.0808 70.8725C30.9269 69.7522 29.398 69.1006 27.7908 69.044C26.9609 67.245 25.5688 65.7646 23.8244 64.8257C22.08 63.8868 20.0778 63.5403 18.1193 63.8385C16.1609 64.1366 14.3525 65.0633 12.9664 66.4787C11.5803 67.8942 10.6918 69.7219 10.4347 71.6864H10.3538C9.67526 71.6864 9.00341 71.8202 8.37666 72.0801C7.7499 72.34 7.18055 72.721 6.70116 73.2012C6.22177 73.6815 5.84176 74.2515 5.58287 74.8788C5.32398 75.506 5.19129 76.1782 5.19239 76.8568Z"
        fill="url(#paint4_linear_16789_183495)"
      />
      <path
        d="M10.0562 19.9863C10.0562 21.0224 10.4677 22.016 11.2002 22.7486C11.9327 23.4811 12.9261 23.8927 13.9621 23.8927H26.9297C28.2073 23.8859 29.4319 23.3805 30.3425 22.4841C31.253 21.5877 31.7776 20.3711 31.8046 19.0935C31.8315 17.816 31.3586 16.5784 30.4866 15.6444C29.6146 14.7104 28.4124 14.1538 27.1361 14.0933C26.5067 12.7373 25.4544 11.6221 24.1373 10.9151C22.8203 10.2081 21.3094 9.9475 19.8316 10.1723C18.3539 10.3972 16.9889 11.0954 15.9416 12.1621C14.8943 13.2288 14.2212 14.6065 14.0234 16.0883H13.9648C12.9299 16.0876 11.937 16.4976 11.2041 17.2285C10.4712 17.9594 10.0584 18.9512 10.0562 19.9863Z"
        fill="url(#paint5_linear_16789_183495)"
      />
      <g opacity="0.9">
        <g filter="url(#filter2_b_16789_183495)">
          <rect
            x="39.0796"
            y="34.6797"
            width="26.1578"
            height="26.3516"
            rx="13.0789"
            fill="url(#paint6_linear_16789_183495)"
            fill-opacity="0.9"
          />
          <rect
            x="39.4071"
            y="35.0072"
            width="25.5027"
            height="25.6965"
            rx="12.7514"
            stroke="#6366F1"
            stroke-opacity="0.04"
            stroke-width="0.655099"
          />
        </g>
        <g
          opacity="0.5"
          filter="url(#filter3_f_16789_183495)"
        >
          <path
            d="M38.8704 54.5214C38.8326 54.163 38.8133 53.794 38.8133 53.4152V42.3431C38.8133 37.5457 41.8896 34.3203 46.4838 34.3203H52.7459L55.6174 45.0369C56.5501 48.5178 55.0862 51.0041 51.6727 51.9187L42.262 54.4403C40.9858 54.7823 39.8468 54.804 38.8704 54.5214Z"
            fill="url(#paint7_linear_16789_183495)"
          />
        </g>
        <g filter="url(#filter4_d_16789_183495)">
          <path
            d="M52.2948 41.4531C52.9482 41.4531 53.4927 42.0203 53.4927 42.6977V48.949C53.4927 49.6293 52.9482 50.1794 52.2948 50.1794C51.6414 50.1794 51.1105 49.6293 51.1105 48.949V42.6977C51.1105 42.0203 51.6414 41.4531 52.2948 41.4531Z"
            fill="url(#paint8_linear_16789_183495)"
          />
          <path
            d="M53.4793 53.4333C53.4793 54.1122 52.9484 54.6779 52.2814 54.6779C51.628 54.6779 51.0971 54.1122 51.0971 53.4333C51.0971 52.7545 51.628 52.2029 52.295 52.2029C52.9484 52.2029 53.4793 52.7545 53.4793 53.4333Z"
            fill="url(#paint9_linear_16789_183495)"
          />
          <path
            d="M53.2847 42.6977C53.2847 42.1274 52.8257 41.6611 52.2948 41.6611C51.7668 41.6611 51.3185 42.1243 51.3185 42.6977V48.949C51.3185 49.5218 51.7635 49.9715 52.2948 49.9715C52.8291 49.9715 53.2847 49.5187 53.2847 48.949V42.6977ZM52.2814 54.4699C52.8246 54.4699 53.2713 54.0065 53.2713 53.4333C53.2713 52.8618 52.8261 52.4109 52.295 52.4109C51.7488 52.4109 51.3051 52.8633 51.3051 53.4333C51.3051 54.0081 51.7533 54.4699 52.2814 54.4699Z"
            stroke="url(#paint10_linear_16789_183495)"
            stroke-width="0.415961"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_16789_183495"
          x="17.196"
          y="78.5661"
          width="66.3717"
          height="25.4225"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4.23649"
            result="effect1_foregroundBlur_16789_183495"
          />
        </filter>
        <filter
          id="filter1_d_16789_183495"
          x="61.8143"
          y="0.89527"
          width="44.1857"
          height="32.4753"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset
            dx="4.23649"
            dy="2.82432"
          />
          <feGaussianBlur stdDeviation="4.58953" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_16789_183495"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_16789_183495"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_b_16789_183495"
          x="36.4592"
          y="32.0593"
          width="31.3985"
          height="31.5924"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="1.3102"
          />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_16789_183495"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_16789_183495"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_f_16789_183495"
          x="24.8599"
          y="20.3667"
          width="44.9868"
          height="48.3056"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6.9768"
            result="effect1_foregroundBlur_16789_183495"
          />
        </filter>
        <filter
          id="filter4_d_16789_183495"
          x="45.8977"
          y="36.2536"
          width="23.1936"
          height="34.0246"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset
            dx="5.19951"
            dy="5.19951"
          />
          <feGaussianBlur stdDeviation="5.19951" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.996078 0 0 0 0 0.25098 0 0 0 0 0.25098 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_16789_183495"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_16789_183495"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_16789_183495"
          x1="53.1238"
          y1="-2.51236"
          x2="53.9666"
          y2="141.954"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stop-color="#E5E7EB"
            stop-opacity="0"
          />
          <stop
            offset="1"
            stop-color="#E5E7EB"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_16789_183495"
          x1="22.4352"
          y1="63.139"
          x2="88.1573"
          y2="79.6257"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop
            offset="1"
            stop-color="#E8E8F1"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_16789_183495"
          x1="65.9813"
          y1="17.8352"
          x2="103.274"
          y2="18.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop
            offset="1"
            stop-color="#E5E7EB"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_16789_183495"
          x1="95.0217"
          y1="79.2453"
          x2="80.6249"
          y2="52.9781"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FAF8FF" />
          <stop
            offset="1"
            stop-color="#E4E4ED"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_16789_183495"
          x1="28.5731"
          y1="89.9045"
          x2="14.2378"
          y2="63.7241"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FAF8FF" />
          <stop
            offset="1"
            stop-color="#E4E4ED"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear_16789_183495"
          x1="27.6782"
          y1="29.8439"
          x2="16.852"
          y2="10.0979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FAF8FF" />
          <stop
            offset="1"
            stop-color="#E4E4ED"
          />
        </linearGradient>
        <linearGradient
          id="paint6_linear_16789_183495"
          x1="45.8445"
          y1="38.3144"
          x2="61.0709"
          y2="54.3312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D6D0F5" />
          <stop
            offset="1"
            stop-color="#DDD8FA"
            stop-opacity="0.39"
          />
        </linearGradient>
        <linearGradient
          id="paint7_linear_16789_183495"
          x1="37.6923"
          y1="37.7518"
          x2="55.3911"
          y2="50.4708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B1B2F8" />
          <stop
            offset="1"
            stop-color="#CBD5F9"
          />
        </linearGradient>
        <linearGradient
          id="paint8_linear_16789_183495"
          x1="52.2946"
          y1="42.1991"
          x2="54.5003"
          y2="42.0315"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stop-color="white"
            stop-opacity="0.75"
          />
          <stop
            offset="1"
            stop-color="white"
            stop-opacity="0.2"
          />
        </linearGradient>
        <linearGradient
          id="paint9_linear_16789_183495"
          x1="52.2946"
          y1="42.1991"
          x2="54.5003"
          y2="42.0315"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stop-color="white"
            stop-opacity="0.75"
          />
          <stop
            offset="1"
            stop-color="white"
            stop-opacity="0.2"
          />
        </linearGradient>
        <linearGradient
          id="paint10_linear_16789_183495"
          x1="53.1113"
          y1="42.9938"
          x2="49.4248"
          y2="43.8209"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stop-color="white"
            stop-opacity="0.25"
          />
          <stop
            offset="1"
            stop-color="white"
            stop-opacity="0"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};
